/*
  rr-purchase-events.js — 2026-09-25

  PostHog had zero events anywhere in the actual purchase funnel (no
  add-to-cart, no checkout, no Amazon-click) — confirmed directly against
  the project's event taxonomy, not assumed. Adds the two that have real UI
  to hook: add-to-cart form submits and checkout clicks. Capture-phase,
  passive listeners on document — never call preventDefault, so this can't
  interfere with the theme's own add-to-cart/checkout handling either way
  (AJAX cart or full page submit).

  No "Buy on Amazon" event yet: there is no such link anywhere on the site
  today (checked), so there is nothing to instrument. Add one here the day
  that link exists.
*/
(function () {
  function capture(name, props) {
    try { window.posthog && window.posthog.capture(name, props || {}); } catch (e) {}
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    var variantField = form.querySelector('[name="id"]');
    capture('add_to_cart', {
      path: window.location.pathname,
      variant_id: variantField ? variantField.value : null
    });
  }, true);

  document.addEventListener('click', function (e) {
    var el = e.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]');
    if (!el) return;
    capture('checkout_started', { path: window.location.pathname });
  }, true);

  /*
    2026-10-31. Product-card / grid "add" buttons (.js-grid-cart) add by AJAX and never submit a form,
    so the submit listener above cannot see them (PostHog had no add_to_cart for them). Same event
    name, plus source:'grid' so the two paths can be told apart. Disabled (sold-out) buttons are skipped.
  */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-grid-cart');
    if (!btn || btn.classList.contains('disabled')) return;
    capture('add_to_cart', {
      path: window.location.pathname,
      variant_id: btn.getAttribute('data-id'),
      source: 'grid'
    });
  }, true);

  /*
    2026-10-31. Where AI-referred visitors go next. Our Story is a common landing page for ChatGPT
    visits, so its shop buttons and every link to the wholesale page are named events.
      story_cta_clicked      - a shop/product link clicked on /pages/our-story
      wholesale_link_clicked - any link to the wholesale page, from any page
      wholesale_form_started / _submitted / _confirmed - the enquiry form on the wholesale page
  */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var label = (a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60);
    if (/wholesale/.test(href)) {
      capture('wholesale_link_clicked', { from: window.location.pathname, href: href, label: label });
    }
    if (window.location.pathname.indexOf('/pages/our-story') === 0 && /\/(collections|products)\//.test(href)) {
      capture('story_cta_clicked', { href: href, label: label });
    }
  }, true);

  var wsForm = document.querySelector('#wholesale-enquiry form');
  if (wsForm) {
    var wsStarted = false;
    wsForm.addEventListener('focusin', function () {
      if (wsStarted) return;
      wsStarted = true;
      capture('wholesale_form_started', { path: window.location.pathname });
    });
    wsForm.addEventListener('submit', function () {
      capture('wholesale_form_submitted', { path: window.location.pathname });
    });
  }
  if (/[?&]contact_posted=true/.test(window.location.search) && document.getElementById('wholesale-enquiry')) {
    capture('wholesale_form_confirmed', { path: window.location.pathname });
  }

  /*
    Email sign-ups (2026-10-04). Every sign-up form on the theme is a native
    Shopify {% form 'customer' %}, which PostHog can't see on its own. A submit
    only means the visitor pressed the button, so two events are sent:
      email_signup_submitted  - the submit (read from the form's own tags)
      email_signup_confirmed  - after Shopify redirects back with
                                ?customer_posted=true, i.e. the contact was saved
    Source is derived from the hidden contact[tags] value each form already sends.
  */
  var PENDING_KEY = 'rrSignupPending';

  function signupMeta(form) {
    var tagsField = form.querySelector('[name="contact[tags]"]');
    var tags = tagsField ? tagsField.value : '';
    var productMatch = /product-([a-z0-9-]+)/.exec(tags);
    var source = 'other';
    if (/source-article/.test(tags)) source = 'article_restock';
    else if (/restock/.test(tags)) source = 'pdp_restock';
    else if (/launch-signup/.test(tags)) source = 'homepage_signup';
    else if (/newsletter/.test(tags)) source = 'newsletter';
    else if (/waitlist/.test(tags)) source = 'waitlist';
    return {
      source: source,
      tags: tags,
      product_handle: productMatch ? productMatch[1] : null,
      form_id: form.id || null,
      path: window.location.pathname
    };
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    if (!form.querySelector('input[name="form_type"][value="customer"]')) return;
    var meta = signupMeta(form);
    capture('email_signup_submitted', meta);
    try { sessionStorage.setItem(PENDING_KEY, JSON.stringify(meta)); } catch (err) {}
  }, true);

  if (/[?&]customer_posted=true/.test(window.location.search)) {
    var pending = null;
    try {
      pending = JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null');
      sessionStorage.removeItem(PENDING_KEY);
    } catch (err) {}
    capture('email_signup_confirmed', pending || { source: 'unknown', path: window.location.pathname });
  }
})();
